/**
 * The small pieces both list screens draw.
 *
 * Home and Slate show the same things in different arrangements, and when the
 * chips were defined twice they drifted twice — one screen called an author's
 * row "Person" while the other said "Author".
 */

import type { WatchItem } from '../lib/model.js';

/** What it is, and what sort of thing it is. Both at a glance, both small. */
export function Chips({ item }: { item: WatchItem }) {
  const category = item.tags[0] ?? null;
  return (
    <span className="chiprow">
      <span className={item.kind === 'creator' ? 'kindtag person' : 'kindtag'}>
        {kindWord(item)}
      </span>
      {category && <span className="kindtag genre">{category}</span>}
    </span>
  );
}

export function kindWord(item: WatchItem): string {
  if (item.kind === 'creator') return item.medium === 'book' ? 'Author' : 'Director';
  if (item.kind === 'series') return 'Series';
  if (item.medium === 'film') return 'Film';
  if (item.medium === 'tv') return 'TV';
  return 'Book';
}
